module.exports = __webpack_public_path__ + "img/24.06a8225e.png";